import React from 'react';
import { reduxForm, Field, formValueSelector, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import withFeatureFlags from 'hocs/withFeatureFlags';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import WarningMessage from 'components/WarningMessage/WarningMessage';
import {
  onClickCancel,
  deleteSalesTypeRequest,
  activatedSalesTypeRequest,
} from 'actions/library/salesType';
import { isDisableOutletLevelForm } from 'utils/userProperties';

import SalesTypeGratuity from './SalesTypeGratuity';
import styles from './style.css';

const validate = values => {
  const errors = {};
  if (!values.name || values.name.trim() === '') {
    errors.name = 'This field is required';
  }
  if (values.name && values.name.length > 25) {
    errors.name = 'Sales Type Name should be less than 25 characters';
  }
  return errors;
};

const popoverAdvancedOrdering = ({ content }) => (
  <Popover id="advancedOrdering">{content}</Popover>
);

const popoverSalesTypeReserved = ({ content }) => (
  <Popover id="advancedOrdering">{content}</Popover>
);

const tooltipDeleteButton = (
  <Popover id="popover-trigger-hover-focus">
    This sales type cannot be deleted. Go to Business Library to delete
  </Popover>
);

const tooltipSaveButton = (
  <Popover id="popover-trigger-hover-focus">
    This sales type cannot be edited. Go to Business Library to modify
  </Popover>
);

const AdvancedOrderingButtonWrapper = ({ isAdvancedOrdering, children }) => {
  if (isAdvancedOrdering) {
    return (
      <OverlayTrigger
        placement="top"
        overlay={popoverAdvancedOrdering({
          content:
            'This sales-type cannot be updated because it was created for receiving orders from advanced ordering.',
        })}
      >
        <div className={styles['btn-wrapper']}>
          <div className={styles['btn-blocker']} />
          <span>{children}</span>
        </div>
      </OverlayTrigger>
    );
  }
  return <span>{children}</span>;
};

const SalesTypeReservedButtonWrapper = ({ isEditableGratuity, children }) => {
  if (isEditableGratuity) {
    return (
      <OverlayTrigger
        placement="top"
        overlay={popoverSalesTypeReserved({
          content:
            'This sales-type cannot be updated because it was created for Reserved Sales Type only.',
        })}
      >
        <div className={styles['btn-wrapper']}>
          <div className={styles['btn-blocker']} />
          <span>{children}</span>
        </div>
      </OverlayTrigger>
    );
  }
  return <span>{children}</span>;
};

class SalesTypeForm extends React.Component {
  constructor(props) {
    super(props);
    this.scrollArea = null;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.mustScrollTop) {
      this.scrollArea.scrollTop = 0;
    }
  }

  render() {
    const {
      handleSubmit,
      isSubmittingForm,
      salesTypeDetail,
      outlets,
      gratuity,
      enableGratuity,
      businessLibraryMenu,
      salesTypeReserved,
      allowEditableGratuity,
    } = this.props;

    let textActivatedBtn = '';
    let styleBtnColor = '';
    const isActivate = salesTypeDetail && salesTypeDetail.active_state === true;
    isActivate
      ? (textActivatedBtn = 'Deactivate')
      : (textActivatedBtn = 'Reactivate');
    isActivate
      ? (styleBtnColor = `btn btn-danger ${styles.btnActivate}`)
      : (styleBtnColor = `btn btn-primary ${styles.btnActivate}`);

    const isAdvancedOrderingSalesType =
      (salesTypeDetail && salesTypeDetail.is_advance_ordering) ||
      (salesTypeReserved && !salesTypeReserved.is_gratuity_editable);
    const isDisableForm = isDisableOutletLevelForm(
      businessLibraryMenu,
      salesTypeDetail
    );
    const isEditableGratuitySalesType =
      allowEditableGratuity &&
      salesTypeReserved &&
      salesTypeReserved.is_gratuity_editable;

    return (
      <div
        onSubmit={this.props.handleSubmit}
        className={`${styles.wrapper} sales-type-wrapper-form`}
      >
        <div
          ref={a => {
            this.scrollArea = a;
          }}
          className={
            !enableGratuity
              ? `${
                  styles['item-fieldset-without-gratuity-warning']
                } sales-type-item-fieldset`
              : `${styles['item-fieldset']} sales-type-item-fieldset`
          }
        >
          {isAdvancedOrderingSalesType && (
            <div className={styles['fieldset-blocker']} />
          )}
          <div className={styles.title}>Sales Type Information</div>
          <div className="row">
            <div className="col-sm-12 mb-30px">
              <div className="col-sm-12 col-md-12 no-padding">
                <Field
                  component={SettingField}
                  name="name"
                  className="form-control"
                  placeholder="Sales Type Name (e.g. Dine In)"
                  dis={isEditableGratuitySalesType ? true : isDisableForm}
                />
              </div>
            </div>
            <div className="col-lg-12 col-sm-12">
              <div className="form-group">
                <label className={`${styles['label-input']}`}>
                  Assign Gratuity
                </label>
                {gratuity.results && gratuity.results.length > 0 ? (
                  <FieldArray
                    name="active_gratuities"
                    component={SalesTypeGratuity}
                    gratuity={gratuity}
                  />
                ) : (
                  <div className={styles.textNoGratuity}>
                    No Gratuity found. Go to Gratuity page to manage Gratuity
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            !enableGratuity
              ? styles.footerWithoutGratuityWarning
              : styles.footer
          }
        >
          {!enableGratuity && (
            <div className={styles['warning-message']}>
              <WarningMessage
                addPadding={styles.addPadding}
                message="Your Checkout Settings for Gratuity is disabled. The Gratuity will not be applied to the transactions"
              />
            </div>
          )}
          {salesTypeDetail && salesTypeDetail.id && (
            <span className="pull-left">
              <SalesTypeReservedButtonWrapper
                isEditableGratuity={isEditableGratuitySalesType}
              >
                <AdvancedOrderingButtonWrapper
                  isAdvancedOrdering={isAdvancedOrderingSalesType}
                >
                  {isDisableForm ? (
                    <OverlayTrigger
                      trigger={['hover', 'focus']}
                      placement="top"
                      overlay={tooltipDeleteButton}
                    >
                      <button
                        className={`btn ${styles['disabled-button']}`}
                        type="button"
                        onClick={e => e.preventDefault()}
                      >
                        <i className="fa fa-trash" />
                      </button>
                    </OverlayTrigger>
                  ) : (
                    <button
                      className={'btn btn-danger'}
                      onClick={this._onClickDelete}
                      type="button"
                      disabled={isSubmittingForm}
                    >
                      <i className="fa fa-trash" />
                    </button>
                  )}
                </AdvancedOrderingButtonWrapper>
              </SalesTypeReservedButtonWrapper>
              <span style={{ marginLeft: '10px' }}>
                <AdvancedOrderingButtonWrapper
                  isAdvancedOrdering={isAdvancedOrderingSalesType}
                >
                  <SalesTypeReservedButtonWrapper
                    isEditableGratuity={isEditableGratuitySalesType}
                  >
                    {isDisableForm ? (
                      <OverlayTrigger
                        trigger={['hover', 'focus']}
                        placement="top"
                        overlay={tooltipSaveButton}
                      >
                        <button
                          className={`btn ${styles['disabled-button']}`}
                          type="button"
                          onClick={e => e.preventDefault()}
                        >
                          {textActivatedBtn}
                        </button>
                      </OverlayTrigger>
                    ) : (
                      <button
                        type="button"
                        className={styleBtnColor}
                        onClick={this._onClickActivated}
                        disabled={isSubmittingForm}
                      >
                        {textActivatedBtn}
                      </button>
                    )}
                  </SalesTypeReservedButtonWrapper>
                </AdvancedOrderingButtonWrapper>
              </span>
            </span>
          )}
          <span className="pull-right">
            <button
              type="button"
              className={`btn btn-default ${styles['btn-cancel']}`}
              onClick={this._onClickCancel}
              disabled={isSubmittingForm}
            >
              Cancel
            </button>
            {outlets.length > 1 && salesTypeDetail === null && (
              <button
                type="button"
                className={`btn btn-primary mr-10px`}
                onClick={handleSubmit(this._onSubmitToAllOutlet)}
                disabled={isSubmittingForm}
              >
                Save to All Outlets
              </button>
            )}
            <span style={{ marginRight: '10px' }}>
              <AdvancedOrderingButtonWrapper
                isAdvancedOrdering={isAdvancedOrderingSalesType}
              >
                <button
                  className={`btn btn-primary ${styles['btn-save']}`}
                  onClick={handleSubmit(this._onSubmit)}
                  type="button"
                  disabled={isSubmittingForm}
                >
                  Save
                </button>
              </AdvancedOrderingButtonWrapper>
            </span>
          </span>
        </div>
      </div>
    );
  }

  _onClickCancel = event => {
    this.props.dispatch(onClickCancel());
    event.preventDefault();
    event.stopPropagation();
  };

  _onClickDelete = event => {
    const { dispatch, salesTypeDetail } = this.props;
    dispatch(deleteSalesTypeRequest(salesTypeDetail));
    event.preventDefault();
    event.stopPropagation();
  };

  _onClickActivated = event => {
    const { dispatch, salesTypeDetail } = this.props;
    dispatch(activatedSalesTypeRequest(salesTypeDetail));
    event.preventDefault();
    event.stopPropagation();
  };

  _onSubmitToAllOutlet = values => {
    this.props.onSubmit({ ...values, action: 'saveToAllOutlet' });
  };

  _onSubmit = values => {
    this.props.onSubmit({ ...values, action: 'save' });
  };
}

const selector = formValueSelector('salesType');

const mapForm = {
  form: 'salesType',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

function mapStateToProps(state) {
  const {
    salesType,
    salesTypeDetail,
    outlets,
    isSubmittingForm,
    gratuity,
    enableGratuity,
    salesTypeReserved,
  } = state.library.salesType;
  return {
    salesType,
    salesTypeDetail,
    outlets,
    salesTypeId: { id: selector(state, 'id') },
    isSubmittingForm,
    gratuity,
    enableGratuity,
    salesTypeReserved,
  };
}

SalesTypeForm.defaultProps = {
  allowEditableGratuity: false,
};

const mapFlagsToProps = flags => ({
  businessLibraryMenu: flags.businessLibraryMenu,
  allowEditableGratuity: flags.editableGratuity,
});

const connected = connect(mapStateToProps)(reduxForm(mapForm)(SalesTypeForm));

export default withFeatureFlags(mapFlagsToProps)(connected);
